import React, { useState } from 'react';
import { LoadingSpinner } from '../common/Badges';
import SignaturePad from '../common/SignaturePad';
import { api } from '../../utils/api';
import { toast } from 'sonner';

const InvoiceView = ({ detail, onClose, onSigned }) => {
  const [localSignature, setLocalSignature] = useState(null);
  const printInvoice = () => {
    const printWindow = window.open('', '_blank');
    const content = document.getElementById('invoice-print-area').innerHTML;
    printWindow.document.write(`<html><head><title>Invoice ${detail?.invoice_number}</title><style>
      body { font-family: Arial, sans-serif; padding: 40px; color: #333; max-width: 800px; margin: 0 auto; }
      .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 30px; border-bottom: 3px solid #dc2626; padding-bottom: 20px; }
      .logo-area { font-size: 24px; font-weight: bold; color: #dc2626; }
      .company-info { text-align: right; font-size: 12px; color: #666; }
      .invoice-title { font-size: 28px; font-weight: bold; color: #333; margin-bottom: 5px; }
      .invoice-number { font-size: 14px; color: #666; }
      .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 30px; margin-bottom: 30px; }
      .section-title { font-size: 12px; text-transform: uppercase; color: #999; margin-bottom: 8px; font-weight: bold; }
      .client-name { font-size: 16px; font-weight: bold; margin-bottom: 4px; }
      table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
      th { background: #f3f4f6; padding: 10px; text-align: left; font-size: 12px; text-transform: uppercase; color: #666; }
      td { padding: 10px; border-bottom: 1px solid #eee; font-size: 14px; }
      .total-row { font-weight: bold; font-size: 18px; background: #fef2f2; }
      .total-row td { color: #dc2626; }
      .footer { margin-top: 40px; padding-top: 20px; border-top: 1px solid #eee; text-align: center; font-size: 11px; color: #999; }
      .work-log { background: #f9fafb; padding: 12px; margin-bottom: 8px; border-left: 3px solid #dc2626; }
      .status-badge { display: inline-block; padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: bold; }
      .status-paid { background: #dcfce7; color: #166534; }
      .status-unpaid { background: #fef3c7; color: #92400e; }
    </style></head><body>${content}</body></html>`);
    printWindow.document.close();
    printWindow.print();
  };

  if (!detail) return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="card p-8"><LoadingSpinner /></div>
    </div>
  );

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-testid="invoice-modal">
      <div className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="bg-gray-900 p-4 flex items-center justify-between sticky top-0 z-10">
          <h3 className="text-white font-bold">Invoice {detail.invoice_number}</h3>
          <div className="flex gap-2">
            <button onClick={printInvoice} className="btn-primary text-sm" data-testid="print-invoice-btn">Download / Print</button>
            <button onClick={onClose} className="btn-secondary text-sm">Close</button>
          </div>
        </div>

        <div id="invoice-print-area" className="p-8 bg-white text-gray-800">
          <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '30px', borderBottom: '3px solid #dc2626', paddingBottom: '20px' }}>
            <div>
              {detail.logo_url && <img src={detail.logo_url} alt="Logo" style={{ height: '50px', marginBottom: '8px' }} />}
              <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#dc2626' }}>BELLAJA</div>
              <div style={{ fontSize: '12px', color: '#666' }}>Electrical & Security Systems</div>
            </div>
            <div style={{ textAlign: 'right', fontSize: '12px', color: '#666' }}>
              <p style={{ fontWeight: 'bold', color: '#333' }}>{detail.company?.address || '2195 Muliner Ave, 10462 NY / Bronx'}</p>
              <p>Phone: {detail.company?.phone || '(203) 803-7035'}</p>
              <p>Email: {detail.company?.email || 'fbellajaa@gmail.com'}</p>
              <p>{detail.company?.tagline || 'Licensed & Insured | NYC DOB Certified'}</p>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#333', marginBottom: '5px' }}>INVOICE</h1>
            <p style={{ fontSize: '14px', color: '#666' }}>#{detail.invoice_number}</p>
            <p style={{ fontSize: '12px', color: '#999' }}>Date: {new Date(detail.created_at).toLocaleDateString()}</p>
            <span style={{ display: 'inline-block', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', background: detail.status === 'paid' ? '#dcfce7' : '#fef3c7', color: detail.status === 'paid' ? '#166534' : '#92400e', marginTop: '8px' }}>
              {detail.status.toUpperCase()}
            </span>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginBottom: '30px' }}>
            <div>
              <p style={{ fontSize: '12px', textTransform: 'uppercase', color: '#999', marginBottom: '8px', fontWeight: 'bold' }}>Bill To</p>
              <p style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' }}>{detail.customer_name}</p>
              {detail.customer_email && <p style={{ fontSize: '13px', color: '#666' }}>{detail.customer_email}</p>}
              {detail.customer_phone && <p style={{ fontSize: '13px', color: '#666' }}>Phone: {detail.customer_phone}</p>}
              {detail.customer_address && <p style={{ fontSize: '13px', color: '#666' }}>{detail.customer_address}</p>}
            </div>
            {detail.service_request && (
              <div>
                <p style={{ fontSize: '12px', textTransform: 'uppercase', color: '#999', marginBottom: '8px', fontWeight: 'bold' }}>Service Details</p>
                <p style={{ fontSize: '14px', fontWeight: 'bold', textTransform: 'capitalize' }}>{detail.service_request.service_type.replace('_', ' ')}</p>
                <p style={{ fontSize: '13px', color: '#666' }}>{detail.service_request.description}</p>
                {detail.ticket_number && <p style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>Ticket: {detail.ticket_number}</p>}
              </div>
            )}
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
            <thead>
              <tr>
                <th style={{ background: '#f3f4f6', padding: '10px', textAlign: 'left', fontSize: '12px', textTransform: 'uppercase', color: '#666' }}>Description</th>
                <th style={{ background: '#f3f4f6', padding: '10px', textAlign: 'right', fontSize: '12px', textTransform: 'uppercase', color: '#666' }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {(detail.items || []).map((item, i) => (
                <tr key={i}>
                  <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontSize: '14px' }}>{item.description}</td>
                  <td style={{ padding: '10px', borderBottom: '1px solid #eee', fontSize: '14px', textAlign: 'right' }}>${item.amount?.toFixed(2)}</td>
                </tr>
              ))}
              <tr style={{ fontWeight: 'bold', fontSize: '18px', background: '#fef2f2' }}>
                <td style={{ padding: '12px', color: '#dc2626' }}>TOTAL</td>
                <td style={{ padding: '12px', color: '#dc2626', textAlign: 'right' }}>${detail.total?.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          {detail.work_logs && detail.work_logs.length > 0 && (
            <div style={{ marginBottom: '20px' }}>
              <p style={{ fontSize: '12px', textTransform: 'uppercase', color: '#999', marginBottom: '8px', fontWeight: 'bold' }}>Work Performed</p>
              {detail.work_logs.map((log, i) => (
                <div key={i} style={{ background: '#f9fafb', padding: '12px', marginBottom: '8px', borderLeft: '3px solid #dc2626' }}>
                  <p style={{ fontWeight: 'bold', fontSize: '14px' }}>{log.service_performed}</p>
                  <p style={{ fontSize: '13px', color: '#666' }}>{log.description}</p>
                  {log.materials_used && <p style={{ fontSize: '12px', color: '#999' }}>Materials: {log.materials_used}</p>}
                  <p style={{ fontSize: '11px', color: '#bbb' }}>Tech: {log.technician_name} | {new Date(log.created_at).toLocaleDateString()}</p>
                </div>
              ))}
            </div>
          )}

          <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #eee', textAlign: 'center', fontSize: '11px', color: '#999' }}>
            <p>Thank you for choosing BELLAJA Electrical & Security Systems!</p>
            <p>{detail.company?.address || '2195 Muliner Ave, 10462 NY / Bronx'} | {detail.company?.phone || '(203) 803-7035'} | {detail.company?.email || 'fbellajaa@gmail.com'}</p>
          </div>
        </div>

        {/* Signature section - lives outside the print area but in the modal */}
        <SignatureSection detail={detail} localSignature={localSignature} setLocalSignature={setLocalSignature} onSigned={onSigned} />
      </div>
    </div>
  );
};

const SignatureSection = ({ detail, localSignature, setLocalSignature, onSigned }) => {
  const existing = localSignature || detail.client_signature;

  const handleSign = async ({ signature, signer_name, agreed }) => {
    try {
      await api(`/api/invoices/${detail.id}/sign`, {
        method: 'POST',
        body: JSON.stringify({ signature, signer_name, agreed }),
      });
      const signedAt = new Date().toISOString();
      setLocalSignature({ data_url: signature, signer_name, agreed, signed_at: signedAt });
      toast.success('Invoice signed and approved!');
      if (onSigned) onSigned();
    } catch (err) {
      toast.error(err.message || 'Failed to sign invoice');
    }
  };

  return (
    <div className="p-6 border-t border-gray-200 bg-gray-50" data-testid="invoice-signature-section">
      <p className="text-xs font-bold uppercase tracking-wider text-gray-500 mb-3">Customer Signature</p>
      {existing ? (
        <div className="bg-white border border-gray-200 rounded-lg p-4" data-testid="invoice-signed-display">
          <img src={existing.data_url} alt="Customer signature" className="h-20 mx-auto" />
          <div className="mt-3 pt-3 border-t border-gray-100 text-center text-xs text-gray-600">
            <p className="font-bold text-gray-800">{existing.signer_name}</p>
            <p>Signed on {new Date(existing.signed_at).toLocaleString()}</p>
            <p className="text-green-600 mt-1">✓ Approved & authorized</p>
          </div>
        </div>
      ) : (
        <SignaturePad onSign={handleSign} signerName={detail.customer_name || ''} />
      )}
    </div>
  );
};

export default InvoiceView;
